import { EditOutlined } from '@ant-design/icons';
import { Checkbox } from 'antd';
import { ColumnsType } from 'antd/lib/table';

import { Button } from '../../../../../../components/index';
import {
  formatNumberToLocale,
  isNullOrUndefined,
} from '../../../../../../utils/utils';

export function columns(
  onSelectItem: (record: any) => void,
  selectedItemIds: number[],
  onToggleItem: (record: Record<string, any>) => void,
  headerChecked: boolean,
  headerIndeterminate: boolean,
  onToggleHeader: () => void,
  isVehicleManifest: boolean,
  selectedOpDirectionManifest: string,
  hasVolume: boolean,
  isTogglingAll: boolean
): ColumnsType<Record<string, any>> {
  const columns: any[] = [
    {
      title: () => (
        <Checkbox
          checked={headerChecked}
          indeterminate={headerIndeterminate}
          disabled={isTogglingAll}
          onChange={onToggleHeader}
        />
      ),
      width: '5%',
      dataIndex: 'check_all',
      render(_: any, record: Record<string, any>) {
        // Cargas já atribuídas não entram no lote (usar o botão de editar da linha).
        if (!isNullOrUndefined(record.operator)) {
          return <span />;
        }
        return (
          <Checkbox
            checked={selectedItemIds.includes(record.ncm_item_id)}
            onChange={() => onToggleItem(record)}
          />
        );
      },
    },
    {
      title:
        selectedOpDirectionManifest === 'LOADING'
          ? 'EMBARCADOR'
          : 'CONSIGNATÁRIO',
      dataIndex: ['operator_company', 'name'],
      defaultSortOrder: 'ascend' as const,
      width: '15%',
    },
  ];
  if (isVehicleManifest) {
    columns.push({
      title: 'CHASSIS',
      dataIndex: 'chassis',
      defaultSortOrder: 'ascend' as const,
      width: '10%',
    });
  }
  columns.push(
    {
      title: 'CE MERCANTE',
      dataIndex: 'code',
      width: '15%',
    },
    {
      title: 'NCM',
      dataIndex: 'ncm_code',
      width: '10%',
    }
  );
  if (!isVehicleManifest) {
    columns.push({
      title: 'PESO TOTAL',
      dataIndex: 'weight',
      width: '15%',
      render(value: number) {
        return <>{formatNumberToLocale(value)} ton</>;
      },
    });
  }
  columns.push({
    title: 'ARMAZENAMENTO',
    dataIndex: ['storage_terminal', 'name'],
    width: '15%',
  });
  if (!isVehicleManifest) {
    columns.push({
      title: 'QUANTIDADE',
      dataIndex: 'amount',
      width: '10%',
      render(value: number) {
        return <span>{value ? Math.trunc(value) : null}</span>;
      },
    });
    if (hasVolume) {
      columns.push({
        title: 'Volume',
        dataIndex: 'volume',
        width: '10%',
        render(value: number) {
          return (
            <span>{value ? `${formatNumberToLocale(value)} m³` : null}</span>
          );
        },
      });
    }
  }
  columns.push({
    title: 'OPERADOR',
    dataIndex: 'edit',
    width: '15%',
    render: (_: any, record: any) => {
      if (isNullOrUndefined(record.operator)) {
        return (
          <Button
            disabled={selectedItemIds.includes(record.ncm_item_id)}
            onClick={() => onSelectItem(record)}
          >
            Selecionar
          </Button>
        );
      }
      return (
        <div>
          <span>{record.operator.name}</span>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onSelectItem(record)}
          />
        </div>
      );
    },
  });
  return columns;
}
